import FormGroup from "../../components/FormGroup/FormGroup";
import MenuGroup from "../../components/MenuGroup/MenuGroup";
import styles from "./Start.module.css";
import Title from "../../components/Tile/Title";
import { Route, Routes, useLocation } from "react-router";
import LinkElement from "../../components/LinkElement/LinkElement";
import { useState, useEffect } from "react";
function Start() {

  const location = useLocation(); // Доступ к текущему расположению

  const searchParams = new URLSearchParams(location.search); // извлекаем параметры из URL
  const tlgIdParam = searchParams.get("tlgId"); // получаем значение параметра tlgId
  const messageParam = searchParams.get("message"); // получаем значение параметра tlgId

  const [initialValue, setInitialValue] = useState("");
  const [comentValue, setCommentValue] = useState("");
  
  useEffect(() => {
    if (tlgIdParam !== null) {
      setInitialValue(tlgIdParam); // устанавливаем начальное значение поля комментария
      setCommentValue(messageParam);
    }
  }, [ ]); // отслеживаем изменения параметра tlgId


  return (
    <>
      <form className={styles.wrapper}>
        <Routes>
          <Route
            path="/frontend-for-bot"
            element={
              <>
                <Title title="Выберите соответствующую форму" />
                <MenuGroup></MenuGroup>
              </>
            }
          />

          <Route
            path="/frontend-for-bot/message"
            element={
              <>
                <Title title="Напишите сообщение" />
                <FormGroup
                  initial={{
                    form: "message",
                    tlgId: tlgIdParam
                  }}
                >

                  <input
                    name="tlgId" value={tlgIdParam}
                  ></input>

                  <FormGroup.InputComment name="comment" text={messageParam} />
                </FormGroup>
              </>
            }
          />

          <Route
            path="feast"
            element={
              <>
                <Title title="Заполните форму заказа Банкета" />
                <LinkElement title="Назад" link="/frontend-for-bot" />

                <FormGroup
                  initial={{
                    form: "order",
                    typeOrder: "feast",
                    city: "Москва",
                  }}
                >
                  {/* <FormGroup.InputSelectTypeOrder name="typeOrder" /> */}
                  <FormGroup.InputNameContact name="nameContact" />
                  <FormGroup.InputPhone name="number" />
                  <FormGroup.InputSelectCity name="city" />
                  <FormGroup.InputComment name="comment" />
                </FormGroup>
              </>
            }
          />
          <Route
            path="wake"
            element={
              <>
                <Title title="Заполните форму заказа Поминок" />
                <LinkElement title="Назад" link="/frontend-for-bot" />
                <FormGroup
                  initial={{
                    form: "order",
                    typeOrder: "wake",
                    city: "Москва",
                    timeWake: "9:00-9:30",
                  }}
                >
                  {/* <FormGroup.InputSelectTypeOrder name="typeOrder" /> */}
                  <FormGroup.InputNameContact name="nameContact" />
                  <FormGroup.InputPhone name="number" />
                  <FormGroup.InputFIO name="fio" />
                  <FormGroup.InputDateLeft name="dateLeft" />
                  <FormGroup.InputDateWake name="dateWake" />
                  <FormGroup.InputSelectTimeWake name="timeWake" />
                  <FormGroup.InputSelectCity name="city" />
                  <FormGroup.InputComment name="comment" />
                </FormGroup>
              </>
            }
          />
          <Route
            path="update"
            element={
              <>
                <Title title="Заполните форму регистрации" />
                <LinkElement title="Назад" link="/frontend-for-bot" />
                <FormGroup initial={{ role: "agent", form: "update" }}>
                  <FormGroup.InputName name="name" />
                  <FormGroup.InputOrganization name="role" />
                  <FormGroup.InputPhone name="number" />
                </FormGroup>
              </>
            }
          />
        </Routes>
      </form>
    </>
  );
}

export default Start;
